import { RampPgApiSdk } from '~api/RampPgApiSdk';
import { ConfigRepository } from '~repositories/ConfigRepository';
import { DropdownDataStore } from '~repositories/DropdownDataStore';
import { UserRepository } from '~repositories/UserRepository';
import { diContainer } from '~setup/diContainer';
import serviceNames from '~setup/RampService';

import { GenerateFieldValidationsUseCase } from './GenerateFieldValidationsUseCase';

export class ConfigurationLoadedUseCase {
    private configRepository: ConfigRepository;
    private dropdownDataStore: DropdownDataStore;
    private userRepository: UserRepository;
    private configNodeName: string;
    private apiSdk: RampPgApiSdk;
    private initFormStore: boolean;

    /**
     * @param configNodeName This should be the fully qualified name, since it will be included as request header for BE to cache the BU configuration
     */
    constructor(configNodeName: string, initFormStore: boolean = true) {
        this.configRepository = diContainer.get(serviceNames.configRepository);
        this.dropdownDataStore = diContainer.get(serviceNames.dropdownDataStore);
        this.userRepository = diContainer.get(serviceNames.userRepository);
        this.apiSdk = diContainer.get(serviceNames.rampPgApiSdk);
        this.configNodeName = configNodeName;
        this.apiSdk.setBusinessUnitConfigNode(configNodeName);
        this.initFormStore = initFormStore;
    }

    execute = () => {
        this.configRepository.loadRampConfigs(this.configNodeName);
        const { iamConfig, signUpFormInitialValues } = this.configRepository;
        // const { iamConfig, signUpFormInitialValues, socialProviders } = this.configRepository;
        if (iamConfig) {
            // Used in RAMP
            // await this.translationRepository.getConfiguredTranslations(
            //     iamConfig.schema.sections || [],
            //     socialProviders
            // );

            this.dropdownDataStore.setup(iamConfig.staticLookupUrls);
            // TODO: update signUpFormInitialValues to standardize RAMP schema and SOCIAL PROFILE schema
            if (this.initFormStore) {
                this.userRepository.initUserFormStore(signUpFormInitialValues);
            }

            new GenerateFieldValidationsUseCase().execute();
            this.configRepository.onSetupReady();
        }
    };
}
